import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ArmazenamentoDeTokenService } from 'src/app/shared/services/armazenamento/armazenamento-de-token.service';

@Injectable({
  providedIn: 'root',
})
export class AutorizacaoGuard {
  private router: Router = inject(Router);
  private armazenamentoDeTokenService = inject(ArmazenamentoDeTokenService)

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      const token = this.armazenamentoDeTokenService.buscarToken();

      if (!token) {
        this.router.navigateByUrl('auth/login')
      }

      resolve(token ? true : false);
    });
  }
}
